export default "__VITE_ASSET__akj4lXV7__"